/* This file is generated from the templates folder by `gulp generate --vl`. */

const defaultValidationTexts = () => {
	jQuery.extend(jQuery.validator.messages, {
		required: 'Dit veld is verplicht.',
		/* remote: 'Please fix this field.', */
		email: 'Vul alstublieft uw e-mailadres in. Op dit e-mailadres sturen wij ook een bevestiging van uw aanmelding en kunnen we u supersnel bereiken als u heeft gewonnen.',
		/* url: 'Please enter a valid URL.', */
		/* date: 'Please enter a valid date.', */
		/* dateISO: 'Please enter a valid date (ISO).', */
		/* number: 'Please enter a valid number.', */
		/* digits: 'Please enter only digits.', */
		/* creditcard: 'Please enter a valid credit card number.', */
		/* equalTo: 'Please enter the same value again.', */
		/* accept: 'Please enter a value with a valid extension.', */
		maxlength: jQuery.validator.format('Voer niet meer dan {0} karakters in dit veld.'),
		/* minlength: jQuery.validator.format('Please enter at least {0} characters.'), */
		/* rangelength: jQuery.validator.format('Please enter a value between {0} and {1} characters long.'), */
		/* range: jQuery.validator.format('Please enter a value between {0} and {1}.'), */

		/* Campaign-specific for birthdate validation messages */
		max: 'Er is iets misgegaan. De ingevoerde datum heeft niet het juiste formaat. Vul uw geboortedatum als volgt in: dd-mm-jjjj.',
		min: 'Er is iets misgegaan. De ingevoerde datum heeft niet het juiste formaat. Vul uw geboortedatum als volgt in: dd-mm-jjjj.'
	});
};

export default defaultValidationTexts;
